const React = require('react');
const SelectReg = require('./Reg');


module.exports = ({
  className,
  helperText,
  ...props
}) => {
  return (
    <div className={'rlv ' + (className || '')}>
      <SelectReg
        className="w"
        {...props}
      />
      {
        props.error ? (<div className="rlv">
          <div
            className="abs sh20 st1 f12 cEC4C4C fw4"
          >{helperText || 'Obligatory field'}</div>
        </div>) : null
      }
    </div>
  );
};
